"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleRefundFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.saleRefundFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    amount: Mocks.clare.amountTen,
    created_by_user_id: Mocks.persona.id,
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
    status: 'failed',
    sale_transaction_id: Mocks.clare.saleId,
    sale_transaction_amount: Mocks.clare.amountTen,
    user_full_name: Mocks.persona.full_name,
    sale_id: Mocks.clare.saleId,
    sale_number: Mocks.clare.saleNumber,
    memo: 'memo'
});
